export default __webpack_public_path__ + "static/media/Logo.62f36fbb.svg";